import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/util/view/header/HeaderView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/view/category/CategoriesView.tsx");
